export default __webpack_public_path__ + "static/media/login-bg-2.3be5f348.jpg";